import { render, staticRenderFns } from "./PaperCheck.vue?vue&type=template&id=6c4f7ba6&scoped=true&"
import script from "./PaperCheck.vue?vue&type=script&lang=ts&"
export * from "./PaperCheck.vue?vue&type=script&lang=ts&"
import style0 from "./PaperCheck.vue?vue&type=style&index=0&id=6c4f7ba6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4f7ba6",
  null
  
)

export default component.exports